/* eslint-disable @typescript-eslint/no-explicit-any*/
import {
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  OutlinedInputProps,
} from '@mui/material';
import {useState} from 'react';

export type TextAreaInputProps = {
  showCharacterCounter?: boolean;
  inputDefaults: any;
} & OutlinedInputProps;

const TextAreaInput: React.FC<TextAreaInputProps> = ({
  showCharacterCounter,
  inputDefaults,
  ...props
}) => {
  const [textLength, setTextLength] = useState<number>(0);

  const handleFormWatch = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const {value} = event.target;
    if (showCharacterCounter) {
      const text = value || '';
      setTextLength(text.length);
    }
    if (inputDefaults?.onChange) {
      inputDefaults.onChange(event);
    }
  };

  const getHelperText = (): string => {
    const {inputProps} = props;
    const maxCharacters = inputProps?.maxLength || 300;
    if (showCharacterCounter) {
      return `${textLength}/${maxCharacters}`;
    }
    return '';
  };

  return (
    <FormControl className="w-full" variant="outlined">
      {props.label && <InputLabel>{props.label}</InputLabel>}
      <OutlinedInput
        {...inputDefaults}
        {...props}
        className="w-full"
        onChange={handleFormWatch}
      />
      {showCharacterCounter && (
        <FormHelperText className="flex flex-row-reverse">
          {getHelperText()}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default TextAreaInput;
